import { useFormContext } from 'react-hook-form';

import { addContactInformationFormRefine } from '@/components/modules/Application/components/ContactInformation/_shared/schemas/contactInformationForm.schema';
import { useApplicationNavigation } from '@/components/modules/Application/hooks/useApplicationNavigation';
import { IberiaCardsNav } from '@/components/modules/Application/IberiaCards/_shared/components/IberiaCardsNav';
import { ShortContactFormFields } from '@/components/modules/Application/IberiaCards/modules/ShortContactForm/components/ShortContactFormFields';
import { useCreateStandsCreditCard } from '@/components/modules/Application/IberiaCards/modules/ShortContactForm/hooks/useCreateStandsCreditCard';
import {
  ShortContactFormBaseSchema,
  ShortContactFormType,
} from '@/components/modules/Application/IberiaCards/modules/ShortContactForm/schemas/ShortContactForm.schema';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { FormWrapper } from '@/components/shared/components/FormWrapper';
import { DefaultDialCodeOption } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/constants/DefaultDialCodeOption';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { useApplicationContext } from '@/contexts/ApplicationContext/ApplicationContext';

export const ShortContactForm = () => {
  const { getTextIdTranslation: t } = useTranslation();
  const {
    state: { iberiaCardsStandsContact },
  } = useApplicationContext();

  return (
    <FormWrapper
      formSchema={() => addContactInformationFormRefine(ShortContactFormBaseSchema(t), t)}
      defaultValues={
        iberiaCardsStandsContact ?? {
          firstName: '',
          lastName: '',
          dialCode: DefaultDialCodeOption,
          phoneNumber: '',
          email: '',
          documentNumber: '',
          optIn: false,
        }
      }
    >
      <ShortContactFormContent />
    </FormWrapper>
  );
};

const ShortContactFormContent = () => {
  const { onPrev } = useApplicationNavigation();
  const { formState, getValues } = useFormContext<ShortContactFormType>();
  const {
    actions: { updateApplicationContext },
  } = useApplicationContext();
  const { onSubmit, loading } = useCreateStandsCreditCard();

  const handlePrev = () => {
    updateApplicationContext({ iberiaCardsStandsContact: getValues() });
    onPrev?.();
  };

  return (
    <FlexColumn gridGap={32}>
      <Font variant="body1" color="textPrimary">
        <Text tId="IBERIA_CARDS_STANDS_SHORT_CONTACT_FORM_INTRO" />
      </Font>
      <CustomPaper fill="paper">
        <ShortContactFormFields />
      </CustomPaper>
      <IberiaCardsNav onNext={onSubmit} onPrev={handlePrev} disableNext={!formState.isValid} loading={loading} />
    </FlexColumn>
  );
};
